import type { Audience, StepId } from './types'

/**
 * Step-rækkefølgen pr. målgruppe. De to chat-flows er bevidst forskellige:
 *
 *   - unge:   `claims` (skader-spørgsmålet) er droppet — flowet skal være så
 *             kort som muligt for ung-segmentet, og skader-info bruges ikke i
 *             prissætningen for unge i samme grad som for ældre. `km`
 *             beholdes (kørselsmønster er prissignal for ung-bilist).
 *   - aeldre: `claims` beholdes (skader er prissignal for senior-segmentet).
 *             `km` er droppet — feedback fra aeldre-flowet var at km-spørgsmålet
 *             følte sig irrelevant og forlængede flowet uden tydelig værdi.
 *
 * Bemærk: backend `functions/lib/env.ts` har sin egen, parallelle definition
 * pr. variant+audience — hold dem synkroniseret hvis flowet ændres.
 */
export const STEP_ORDER: Record<Audience, readonly StepId[]> = {
  unge: [
    'welcome',
    'insurances',
    'postnr',
    'age',
    'currentPrice',
    'km',
    'phone',
    'thankyou',
  ],
  aeldre: [
    'welcome',
    'insurances',
    'postnr',
    'age',
    'currentPrice',
    'claims',
    'phone',
    'thankyou',
  ],
} as const

export const PRIVACY_POLICY_URL = 'https://www.fforsikring.dk/politikker/privatlivspolitik'
export const HOMEPAGE_URL = 'https://www.fforsikring.dk'
export const COVERAGE_URL = 'https://www.fforsikring.dk/forsikringer'
export const TRUSTPILOT_URL = 'https://dk.trustpilot.com/review/fforsikring.dk'

// Inline consent shown under the phone field. Submitting the phone number is
// the consent moment; this exact text is logged to consent_log for the GDPR
// Art. 7(1) audit trail.
export const CONSENT_TEXT_REQUIRED =
  'Ved at indsende dit telefonnummer accepterer du Fælles Forsikrings privatlivspolitik og at blive kontaktet af en forsikringsrådgiver med et uforpligtende tilbud.'
